import { createContext, useContext, useEffect, useState, useCallback } from "react";

export const LANGS = [
  { code: "en", label: "EN", name: "English" },
  { code: "es", label: "ES", name: "Español" },
];

const STRINGS = {
  en: {
    all: "All",
    loading: "Loading…",
    noPosts: "No posts yet.",
    noTag: 'No posts tagged “{tag}”.',
    viewOnMap: "View on map",
    website: "Website",
    suggestEdit: "Own this business? Suggest an edit",
    suggestTitle: "Suggest an edit",
    suggestNamePh: "Your name (optional)",
    suggestEmailPh: "Your email (optional)",
    suggestMsgPh: "What should be changed? (hours, phone, description…)",
    suggestSubmit: "Send",
    suggestThanks: "Thanks! We'll review your suggestion.",
    language: "Language",
    mapTitle: "Map",
    mapSub: "San Juanillo, Guanacaste — Costa Rica",
    mapEmpty: "No locations to show yet.",
    directions: "Directions",
    addEvent: "Add Event",
    addPlace: "Add Place",
    submitEventTitle: "Add an Event",
    submitPlaceTitle: "Add a Place",
    submitSub: "Submissions are reviewed before appearing on the site.",
    fEventName: "Event name",
    fPlaceName: "Place name",
    fEventDate: "Event date",
    fCategory: "Category",
    fCategorySelect: "Select a category…",
    fDescription: "Description",
    fDescPh: "Tell visitors what to expect.",
    fLocation: "Location (Google Maps link)",
    fContact: "Contact / WhatsApp number",
    fWebsite: "Website (optional)",
    fBusinessEmail: "Contact email (optional)",
    fImage: "Image",
    uploadImage: "Upload image",
    replaceImage: "Replace image",
    uploading: "Uploading…",
    removeImg: "Remove",
    fEmail: "Your email",
    cancel: "Cancel",
    submitReview: "Submit for review",
    submitting: "Submitting…",
    thankYou: "Thank you!",
    thankYouEvent: "Your event has been submitted for review. We'll publish it once it's approved.",
    thankYouPlace: "Your place has been submitted for review. We'll publish it once it's approved.",
    done: "Done",
    errTitle: "Please enter a name/title.",
    errEmail: "Please enter a valid email address.",
    errDate: "Please choose the event date.",
    errCategory: "Please choose a category.",
    errImage: "Could not upload that image. Please try another.",
    errGeneric: "Something went wrong. Please try again.",
    helpBubble: "Help",
    helpPromptPre: "Send an instant message to our support team on ",
    helpPromptPost: ".",
    addNew: "Add",
    addNewTitle: "What would you like to add?",
    back: "Back",
    askPlaceholder: "Ask anything about San Juanillo",
    askButton: "Ask",
    askPageSubPre: "Every question is read and answered by a real human. Get ",
    askPageSubLink: "notified in your email",
    askPageSubPost: " when new answers get published.",
    subscribePh: "Your email",
    subscribeBtn: "Subscribe",
    subscribeThanks: "Thank you.",
    askNotifyPrompt: "Get notified when your question has been answered.",
    askEmailPh: "Your email (optional)",
    askNotifyBtn: "Notify me",
    askSkip: "No thanks",
    askDoneMini: "Done! We'll email you when your question is answered.",
    exploreTitle: "Tune into the heartbeat of San Juanillo.",
    allCategories: "All categories",
    chooseCategory: "Choose a category",
    listings: "listings",
    feedNote: "Listings without photos are automatically placed at the bottom of the list. Please send photos to ",
    answersTitle: "Answers",
    answersEmpty: "Answers will appear here once questions are answered.",
    tags: {},
  },
  es: {
    all: "Todos",
    loading: "Cargando…",
    noPosts: "Aún no hay publicaciones.",
    noTag: 'No hay publicaciones con la etiqueta “{tag}”.',
    viewOnMap: "Ver en el mapa",
    website: "Sitio web",
    suggestEdit: "¿Es tu negocio? Sugiere un cambio",
    suggestTitle: "Sugerir un cambio",
    suggestNamePh: "Tu nombre (opcional)",
    suggestEmailPh: "Tu correo (opcional)",
    suggestMsgPh: "¿Qué debería cambiar? (horario, teléfono, descripción…)",
    suggestSubmit: "Enviar",
    suggestThanks: "¡Gracias! Revisaremos tu sugerencia.",
    language: "Idioma",
    mapTitle: "Mapa",
    mapSub: "San Juanillo, Guanacaste — Costa Rica",
    mapEmpty: "Aún no hay ubicaciones para mostrar.",
    directions: "Cómo llegar",
    addEvent: "Agregar evento",
    addPlace: "Agregar lugar",
    submitEventTitle: "Agregar un evento",
    submitPlaceTitle: "Agregar un lugar",
    submitSub: "Las propuestas se revisan antes de aparecer en el sitio.",
    fEventName: "Nombre del evento",
    fPlaceName: "Nombre del lugar",
    fEventDate: "Fecha del evento",
    fCategory: "Categoría",
    fCategorySelect: "Selecciona una categoría…",
    fDescription: "Descripción",
    fDescPh: "Cuéntales a los visitantes qué esperar.",
    fLocation: "Ubicación (enlace de Google Maps)",
    fContact: "Contacto / número de WhatsApp",
    fWebsite: "Sitio web (opcional)",
    fBusinessEmail: "Email de contacto (opcional)",
    fImage: "Imagen",
    uploadImage: "Subir imagen",
    replaceImage: "Reemplazar imagen",
    uploading: "Subiendo…",
    removeImg: "Quitar",
    fEmail: "Tu correo electrónico",
    cancel: "Cancelar",
    submitReview: "Enviar para revisión",
    submitting: "Enviando…",
    thankYou: "¡Gracias!",
    thankYouEvent: "Tu evento se ha enviado para revisión. Lo publicaremos una vez aprobado.",
    thankYouPlace: "Tu lugar se ha enviado para revisión. Lo publicaremos una vez aprobado.",
    done: "Listo",
    errTitle: "Por favor ingresa un nombre/título.",
    errEmail: "Por favor ingresa un correo electrónico válido.",
    errDate: "Por favor elige la fecha del evento.",
    errCategory: "Por favor elige una categoría.",
    errImage: "No se pudo subir esa imagen. Intenta con otra.",
    errGeneric: "Algo salió mal. Inténtalo de nuevo.",
    helpBubble: "Ayuda",
    helpPromptPre: "Envía un mensaje instantáneo a nuestro equipo de soporte por ",
    helpPromptPost: ".",
    addNew: "Agregar",
    addNewTitle: "¿Qué te gustaría agregar?",
    back: "Volver",
    askPlaceholder: "Pregunta lo que sea sobre San Juanillo",
    askButton: "Preguntar",
    askPageSubPre: "Cada pregunta es leída y respondida por una persona real. Recibe un ",
    askPageSubLink: "aviso en tu correo",
    askPageSubPost: " cuando se publiquen nuevas respuestas.",
    subscribePh: "Tu correo",
    subscribeBtn: "Suscribirme",
    subscribeThanks: "¡Gracias!",
    askNotifyPrompt: "Recibe un aviso cuando tu pregunta haya sido respondida.",
    askEmailPh: "Tu correo (opcional)",
    askNotifyBtn: "Avísame",
    askSkip: "No, gracias",
    askDoneMini: "¡Listo! Te escribiremos cuando tu pregunta sea respondida.",
    exploreTitle: "Siente el latido de San Juanillo.",
    allCategories: "Todas las categorías",
    chooseCategory: "Elige una categoría",
    listings: "listados",
    feedNote: "Los listados sin fotos se colocan automáticamente al final de la lista. Envía tus fotos a ",
    answersTitle: "Respuestas",
    answersEmpty: "Las respuestas aparecerán aquí cuando se contesten las preguntas.",
    tags: {
      events: "Eventos",
      food: "Comida",
      grocery: "Supermercado",
      beaches: "Playas",
      retreats: "Retiros",
      clubs: "Clubes",
      shop: "Tienda",
      activities: "Actividades",
    },
  },
};

const I18nContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = typeof localStorage !== "undefined" ? localStorage.getItem("lang") : null;
    return saved === "es" ? "es" : "en";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = "ltr";
  }, [lang]);

  const setLang = useCallback((code) => {
    if (code !== "en" && code !== "es") return;
    localStorage.setItem("lang", code);
    setLangState(code);
  }, []);

  const t = useCallback(
    (key, vars) => {
      let s = (STRINGS[lang] && STRINGS[lang][key]) || STRINGS.en[key] || key;
      if (vars) Object.keys(vars).forEach((k) => { s = s.replace(`{${k}}`, vars[k]); });
      return s;
    },
    [lang]
  );

  const tagLabel = useCallback(
    (tag) => (lang === "es" ? (STRINGS.es.tags[tag] || tag) : tag),
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLang, t, tagLabel, isRTL: false }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
